/*
 * omg storefront enhancements (loaded on product page)
 *  - inject lightweight visual styles into the SectionStore bundle Shadow DOM
 *    (only colors/borders/typography — does NOT change layout flow, so it
 *    can't break the app's natural responsive structure)
 *  - suppress easytabs auto-scroll behavior (scrollIntoView during read)
 */

(function () {
  'use strict';

  var STYLE_ID = 'omg-bundle-style';

  var CSS = [
    /* --- card surface --- */
    '.bundle-option{position:relative !important}',
    '.bundle-option-box{border:1px solid rgba(0,0,0,0.14) !important;border-radius:0 !important;background:transparent !important;box-shadow:none !important;transition:border-color .2s ease,background .2s ease !important}',

    /* selected card */
    '.bundle-option-input:checked + .bundle-option-radio-label .bundle-option-box{border:1px solid #a89bd1 !important;background:rgba(168,155,209,0.05) !important}',

    /* --- radio circle --- */
    '.outlined-circle{border:1.5px solid rgba(0,0,0,0.3) !important;border-radius:50% !important;background:transparent !important;box-shadow:none !important;position:relative !important}',
    '.bundle-option-input:checked + .bundle-option-radio-label .outlined-circle{border:2px solid #a89bd1 !important}',
    '.bundle-option-input:checked + .bundle-option-radio-label .outlined-circle::after{content:"" !important;position:absolute !important;top:3px !important;right:3px !important;bottom:3px !important;left:3px !important;background:#a89bd1 !important;border-radius:50% !important;display:block !important}',

    /* --- typography --- */
    '.bundle-header{color:rgba(0,0,0,0.55) !important;text-transform:lowercase !important;font-family:var(--font-heading-family,inherit) !important;font-weight:500 !important;letter-spacing:0.03em !important}',
    '.title{font-family:var(--font-heading-family,inherit) !important;font-weight:600 !important;color:#000 !important;letter-spacing:0 !important;text-transform:lowercase !important}',
    '.subtitle{color:rgba(0,0,0,0.6) !important;text-transform:lowercase !important}',
    '.discounted-value{font-family:var(--font-heading-family,inherit) !important;font-weight:600 !important;color:#000 !important;letter-spacing:0 !important}',
    '.discounted-label{color:rgba(0,0,0,0.55) !important;font-weight:400 !important}',

    /* --- prices --- */
    '.original{text-decoration:line-through !important;color:rgba(0,0,0,0.45) !important;font-weight:400 !important}',
    '.price-total{color:rgba(0,0,0,0.78) !important;font-weight:600 !important}',

    /* --- inline title badge ("ograničeno vrijeme" near title) --- */
    '.title-badge{background:rgba(168,155,209,0.2) !important;color:#7a5fb0 !important;border-radius:0 !important;border:none !important;text-transform:lowercase !important;font-weight:500 !important;letter-spacing:0 !important;box-shadow:none !important}',

    /* --- corner badge (the one that floats above the card) --- */
    '.badge{background:#a89bd1 !important;color:#fff !important;border-radius:0 !important;border:none !important;text-transform:lowercase !important;font-weight:600 !important;letter-spacing:0.03em !important;box-shadow:none !important}',

    /* disable the shimmer/shine effect */
    '.shine{display:none !important}'
  ].join('\n');

  function inject(host) {
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById(STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    host.shadowRoot.appendChild(style);
    return true;
  }

  function attempt() {
    var hosts = document.querySelectorAll('section-store--bundle-block');
    for (var i = 0; i < hosts.length; i++) inject(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }

  /* keep watching — the custom element may attach its shadow root after load */
  new MutationObserver(attempt).observe(document.documentElement, { childList: true, subtree: true });

  var tries = 0;
  var iv = setInterval(function () {
    attempt();
    if (++tries > 40) clearInterval(iv);
  }, 200);
})();


/*
 * gymshark-style gallery dots — sync .slider-dots__dot.is-active to the
 * existing slider-counter--current value (which the slider JS updates on
 * every slide change). also let dots be clickable to jump slides.
 */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('slider-component').forEach(function (slider) {
      var counter = slider.querySelector('.slider-counter--current');
      var allDots = slider.querySelectorAll('.slider-dots__dot');
      if (!counter || !allDots.length) return;
      /* 2026-10-16: tačkica viška - skrivene slike varijanti (product__media-item--variant) imaju tačku ali nisu slajd. broj tačkica = broj vidljivih slajdova */
      var visible = [].filter.call(slider.querySelectorAll('.slider__slide'), function (sl) { return sl.offsetParent !== null && getComputedStyle(sl).display !== 'none'; }).length;
      [].forEach.call(allDots, function (d, i) { d.hidden = visible > 0 && i >= visible; });
      var dots = [].filter.call(allDots, function (d) { return !d.hidden; });
      if (slider.dataset.omgDots) return; slider.dataset.omgDots = '1';

      var update = function () {
        var idx = parseInt(counter.textContent, 10) - 1;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      };
      new MutationObserver(update).observe(counter, {
        childList: true, characterData: true, subtree: true
      });

      var nextBtn = slider.querySelector('.slider-button--next');
      var prevBtn = slider.querySelector('.slider-button--prev');
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var cur = parseInt(counter.textContent, 10) - 1;
          var diff = i - cur;
          var btn = diff > 0 ? nextBtn : prevBtn;
          if (!btn) return;
          var times = Math.abs(diff);
          for (var k = 0; k < times; k++) btn.click();
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500); /* second pass in case slider mounts late */
})();

/*
 * mark body with `has-product-bundle` when a bundle is on the page
 * so we can scope "hide price + variant picker" CSS to only those
 * products that actually have a bundle. Products without bundle
 * (e.g. lavanda) keep their standalone price + variant pills visible.
 */
(function () {
  'use strict';
  function check() {
    if (document.querySelector('section-store--bundle-block')) {
      document.body.classList.add('has-product-bundle');
      return true;
    }
    return false;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  /* keep checking a few seconds in case bundle is hydrated late */
  var tries = 0;
  var iv = setInterval(function () {
    if (check() || ++tries > 30) clearInterval(iv);
  }, 200);
})();

/*
 * single-open accordion behavior for .omg-acc (custom replacement of EasyTabs)
 * uses ONLY .omg-acc-* class names so EasyTabs can't touch these elements.
 * When you open one .omg-acc__item, sibling open ones close at the same time.
 */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var summary = e.target && e.target.closest && e.target.closest('.omg-acc__summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    var wrapper = details.closest('[data-single-open]');
    if (!wrapper) return;
    /* native toggle happens after this handler; close other open items next tick */
    /* kad se gornja stavka zatvori, sadržaj iznad nestane i stranica "skoči".
       zapamtimo gdje je kliknuti naslov na ekranu i poslije zatvaranja vratimo ga tačno tu. */
    var topBefore = summary.getBoundingClientRect().top;
    setTimeout(function () {
      if (!details.open) return;
      var closedAny = false;
      wrapper.querySelectorAll('.omg-acc__item[open]').forEach(function (other) {
        if (other !== details) { other.removeAttribute('open'); closedAny = true; }
      });
      if (closedAny) {
        var shift = summary.getBoundingClientRect().top - topBefore;
        if (Math.abs(shift) > 1) window.scrollBy({ top: shift, left: 0, behavior: 'instant' });
      }
    }, 0);
  }, true);
})();

/*
 * Custom rating display under the product title.
 * Reads data from judge.me's preview badge (which it injects with
 * data-average-rating and data-number-of-reviews), then builds a clean
 * rating element: stars + numeric score + review count, clickable to
 * smooth-scroll to the reviews widget further down the page.
 *
 * We don't touch the original judge.me badge's data — we just hide its
 * visual output and replace it with ours.
 */
(function () {
  'use strict';

  function pluralizeReviews(n) {
    /* bosnian plural rules: 1 -> recenzija, 2-4 -> recenzije, 5+ -> recenzija */
    var last = n % 10;
    var lastTwo = n % 100;
    if (lastTwo >= 11 && lastTwo <= 14) return n + ' recenzija';
    if (last === 1) return n + ' recenzija';
    if (last >= 2 && last <= 4) return n + ' recenzije';
    return n + ' recenzija';
  }

  function buildStars(score) {
    /* 5 SVG stars, partial fill via width % on the inner overlay */
    var pct = Math.max(0, Math.min(100, (score / 5) * 100));
    var html =
      '<span class="omg-rating__stars" aria-hidden="true">' +
        '<span class="omg-rating__stars-bg">★★★★★</span>' +
        '<span class="omg-rating__stars-fg" style="width:' + pct + '%">★★★★★</span>' +
      '</span>';
    return html;
  }

  function findReviewsAnchor() {
    /* prefer the review widget element; fall back to the wrapper that
       contains it. */
    return (
      document.querySelector('[id*="judge_me_reviews_review_widget"]') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('#shopify-section-template--main-product-product-reviews-2') ||
      null
    );
  }

  function smoothScrollTo(el) {
    if (!el) return;
    var header = document.querySelector('.section-header, sticky-header, header');
    var offset = (header && header.offsetHeight) ? header.offsetHeight + 16 : 16;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function render() {
    var badge = document.querySelector('.jdgm-prev-badge[data-average-rating]');
    if (!badge) return false;

    var avg = parseFloat(badge.getAttribute('data-average-rating')) || 0;
    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;
    if (count <= 0) return true; /* nothing to show but we tried */

    /* avoid double-render if our element already exists */
    if (document.querySelector('.omg-rating')) return true;

    /* hide judge.me's native badge wrapper visually */
    var wrapper = badge.closest('.jdgm-widget.jdgm-preview-badge') || badge;
    wrapper.style.display = 'none';

    /* build our element */
    var formatted = avg.toFixed(1).replace('.', ',');
    var el = document.createElement('a');
    el.className = 'omg-rating';
    el.href = '#reviews';
    el.setAttribute('aria-label', formatted + ' od 5, ' + count + ' ocjena, pogledaj recenzije');
    el.innerHTML =
      buildStars(avg) +
      '<span class="omg-rating__score">' + formatted + '</span>' +
      '<span class="omg-rating__sep" aria-hidden="true">·</span>' +
      '<span class="omg-rating__count">' + pluralizeReviews(count) + '</span>';

    el.addEventListener('click', function (e) {
      e.preventDefault();
      smoothScrollTo(findReviewsAnchor());
    });

    /* insert AFTER the hidden judge.me wrapper, so it shows in the same
       spot the badge used to occupy. */
    wrapper.parentNode.insertBefore(el, wrapper.nextSibling);
    return true;
  }

  function init() {
    if (render()) return;
    /* judge.me may inject the badge after our first attempt; poll for
       up to ~6 seconds, then watch the DOM for late-loaded widgets. */
    var tries = 0;
    var iv = setInterval(function () {
      if (render() || ++tries > 30) clearInterval(iv);
    }, 200);
    new MutationObserver(function () { render(); }).observe(
      document.documentElement,
      { childList: true, subtree: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Sticky add-to-cart bar (feals-style) + mobile bottom sheet.
 * - Shows the bar when the main buy button (.product-form__submit) scrolls
 *   OUT of the viewport, hides it when it's IN view (no doubling up).
 * - Variant pills are PROXIES: clicking one clicks the matching real radio in
 *   the main picker, so <variant-radios> does all the real work. We then mirror
 *   the resulting checked state + price + availability into the bar and sheet.
 * - Mobile: the bar is a single trigger that opens a bottom sheet (pills +
 *   price + "dodaj u korpu" / "kupi odmah"). Buy-now adds then -> /checkout.
 * Runs on both desktop and mobile.
 */
(function () {
  'use strict';

  function init() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;

    var sheet = document.querySelector('[data-sticky-sheet]');

    /* main buy button to observe + read variant state from (mainBtn.form is
       the real product form, so we never touch the wrong one) */
    var mainBtn = document.querySelector('.product-form__submit')
      || document.querySelector('product-form button[type="submit"][name="add"]');
    if (!mainBtn) return;
    var mainForm = mainBtn.form || document.querySelector('product-form form');

    /* leave space at the bottom of the page while the bar is in the DOM */
    document.body.classList.add('has-sticky-atc');

    /* ---- show / hide the bar based on the main button position ----
       Only show once the main button has scrolled ABOVE the viewport (user
       scrolled past it). While it's still below the fold near the top of the
       page it's also "not intersecting", so we must check it's actually above
       (boundingClientRect.top < 0) before showing. */
    function showSticky() {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    }
    function hideSticky() {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
    /* a scroll listener (rAF-throttled) rather than an IntersectionObserver:
       a fast/jump scroll can move the button from not-intersecting-below to
       not-intersecting-above with no threshold crossing, so the observer never
       fires and the bar gets stuck hidden. A direct rect check can't miss it. */
    function update() {
      if (mainBtn.getBoundingClientRect().bottom < 0) showSticky();
      else hideSticky();
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    /* ---- proxy pills: select the matching real option in the main picker ---- */
    function setOption(name, value) {
      var radios = document.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].getAttribute('name') === name && radios[i].value === value) {
          radios[i].click();
          return true;
        }
      }
      var selects = document.querySelectorAll('select');
      for (var s = 0; s < selects.length; s++) {
        if (selects[s].getAttribute('name') === name) {
          selects[s].value = value;
          selects[s].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
      return false;
    }

    function onPillClick(e) {
      var pill = e.target.closest && e.target.closest('[data-sticky-pill]');
      if (!pill) return;
      setOption(pill.getAttribute('data-option-name'), pill.getAttribute('data-option-value'));
      syncState();
    }
    sticky.addEventListener('click', onPillClick);
    if (sheet) sheet.addEventListener('click', onPillClick);

    /* ---- mirror real picker state -> pills, price, availability ---- */
    function selectedValues() {
      var map = {};
      var checked = document.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < checked.length; i++) {
        var n = checked[i].getAttribute('name');
        if (n) map[n] = checked[i].value;
      }
      var selects = document.querySelectorAll('select');
      for (var s = 0; s < selects.length; s++) {
        var sn = selects[s].getAttribute('name');
        if (sn && map[sn] === undefined) map[sn] = selects[s].value;
      }
      return map;
    }

    /* 2026-10-18: piši samo kad se stvarno promijeni (nbsp = razmak) - inače tipografska skripta u theme.liquid
       i ovaj observer vrte jedno drugo ~3x u sekundi (lighthouse tbt 23 s na stranici proizvoda) */
    function setText(el, t) {
      if ((el.textContent || '').replace(/\u00A0/g, ' ') !== String(t).replace(/\u00A0/g, ' ')) el.textContent = t;
    }

    function syncState() {
      var sel = selectedValues();

      /* active pill states (bar + sheet) */
      var pills = document.querySelectorAll('[data-sticky-pill]');
      for (var i = 0; i < pills.length; i++) {
        var p = pills[i];
        var active = sel[p.getAttribute('data-option-name')] === p.getAttribute('data-option-value');
        if (p.classList.contains('is-active') !== active) p.classList.toggle('is-active', active);
        if (p.getAttribute('aria-pressed') !== (active ? 'true' : 'false')) p.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      /* price (mirror the visible main price into every sticky price slot) */
      var priceEl =
        document.querySelector('.price__sale .price-item--sale:not([hidden])') ||
        document.querySelector('.price__regular .price-item--regular:not([hidden])') ||
        document.querySelector('[id^="price-"] .price-item:not([hidden])');
      if (priceEl) {
        var txt = (priceEl.textContent || '').trim();
        if (txt) {
          var slots = document.querySelectorAll('[data-sticky-price]');
          for (var k = 0; k < slots.length; k++) setText(slots[k], txt);
        }
      }

      /* availability — ignore the transient "loading" state the main button
         enters while an add-to-cart request is in flight, otherwise the sticky
         button briefly flips to "nedostupno" for those ~2s */
      var loading = mainBtn.classList.contains('loading')
        || mainBtn.getAttribute('aria-busy') === 'true';
      if (!loading) {
        var unavailable = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        var actions = document.querySelectorAll('[data-sticky-add], [data-sticky-buy-now]');
        for (var a = 0; a < actions.length; a++) if (actions[a].disabled !== !!unavailable) actions[a].disabled = !!unavailable;

        var addBtns = sticky.querySelectorAll('.sticky-atc__button');
        for (var b = 0; b < addBtns.length; b++) {
          setText(addBtns[b], unavailable ? 'nedostupno' : 'ubaci u korpu');
        }
        var trigger = sticky.querySelector('[data-sticky-trigger]');
        if (trigger) setText(trigger, unavailable ? 'nedostupno' : 'ubaci u korpu');
      }
    }

    var watch = document.querySelector('product-info, product-form, .product__info-container');
    if (watch) {
      new MutationObserver(syncState).observe(watch, {
        childList: true, subtree: true, attributes: true, characterData: true
      });
    }
    syncState();

    /* ---- mobile bottom sheet ---- */
    function openSheet() {
      if (!sheet) return;
      document.body.classList.add('sticky-sheet-open');
      void sheet.offsetWidth; /* force reflow so the slide-up transition runs */
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
    }
    function closeSheet() {
      if (!sheet) return;
      var sp = sheet.querySelector('.sticky-sheet__panel'); if (sp) sp.style.transform = '';
      sheet.classList.remove('is-dragging');
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sticky-sheet-open');
    }

    var trigger = sticky.querySelector('[data-sticky-trigger]');
    if (trigger) trigger.addEventListener('click', openSheet);

    /* 2026-10-16: povuci prstom dole = zatvori sheet */
    if (sheet) (function () {
      var panel = sheet.querySelector('.sticky-sheet__panel'); if (!panel) return;
      var sy = 0, dy = 0, st = 0, drag = false;
      panel.addEventListener('touchstart', function (e) {
        var body = sheet.querySelector('.sticky-sheet__body');
        if (body && body.scrollTop > 0 && !(e.target.closest && e.target.closest('.sticky-sheet__header'))) { drag = false; return; }
        drag = true; sy = e.touches[0].clientY; dy = 0; st = Date.now();
      }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (!drag) return; dy = e.touches[0].clientY - sy;
        if (dy <= 0) { panel.style.transform = ''; sheet.classList.remove('is-dragging'); return; }
        if (e.cancelable) e.preventDefault();
        sheet.classList.add('is-dragging'); panel.style.setProperty('--dy', dy + 'px');
      }, { passive: false });
      panel.addEventListener('touchend', function () {
        if (!drag) return; drag = false; sheet.classList.remove('is-dragging');
        if (dy > 110 || (dy > 40 && Date.now() - st < 250)) closeSheet(); panel.style.removeProperty('--dy');
      });
    })();

    if (sheet) {
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet) { closeSheet(); return; }          /* backdrop */
        if (e.target.closest('[data-sticky-sheet-close]')) { closeSheet(); return; }
        /* the add button is type=submit (form=...) -> let it submit, then close */
        if (e.target.closest('[data-sticky-sheet-add]')) { setTimeout(closeSheet, 60); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && sheet.classList.contains('is-open')) closeSheet();
    });

    /* ---- buy now: add the current variant, then go to checkout ---- */
    var buyBtn = sheet ? sheet.querySelector('[data-sticky-buy-now]') : null;
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.disabled) return;
        var idInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
        var variantId = idInput ? idInput.value : null;
        if (!variantId) return;
        var qtyInput = mainForm ? mainForm.querySelector('input[name="quantity"]') : null;
        var qty = qtyInput && qtyInput.value ? Number(qtyInput.value) : 1;
        buyBtn.classList.add('loading');
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/checkout'; });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * mobile-only: tapping an .omg-acc__summary opens a full-screen modal that
 * slides up from the bottom (gymshark-style). Page scroll is locked while the
 * modal is open, so the underlying page never jumps. Desktop is untouched.
 *
 * One shared modal element is appended to <body>; its title + body content
 * are populated from whichever .omg-acc__item was tapped.
 *
 * Single-open behavior above still runs but is harmless here, because we
 * preventDefault() on the summary click so <details> never actually opens
 * on mobile — the modal opens instead.
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  var modal = null;
  var modalTitle = null;
  var modalBody = null;
  var lastFocused = null;

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'omg-acc__modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="omg-acc__modal-panel">' +
        '<div class="omg-acc__modal-header">' +
          '<h2 class="omg-acc__modal-title" id="omg-acc-modal-title"></h2>' +
          '<button type="button" class="omg-acc__modal-close" aria-label="zatvori">' +
            '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
              '<path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="omg-acc__modal-body"></div>' +
      '</div>';
    modal.setAttribute('aria-labelledby', 'omg-acc-modal-title');
    modalTitle = modal.querySelector('.omg-acc__modal-title');
    modalBody = modal.querySelector('.omg-acc__modal-body');

    var closeBtn = modal.querySelector('.omg-acc__modal-close');
    closeBtn.addEventListener('click', closeModal);

    /* tap on the dimmed backdrop (the strip above the panel) closes too */
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    /* 2026-10-16: povuci prstom dole = zatvori (kad je sadržaj na vrhu ili se vuče za zaglavlje) */
    var panel = modal.querySelector('.omg-acc__modal-panel');
    var sy = 0, dy = 0, st = 0, drag = false;
    panel.addEventListener('touchstart', function (e) {
      var onHead = e.target.closest && e.target.closest('.omg-acc__modal-header');
      if (!onHead && modalBody.scrollTop > 0) { drag = false; return; }
      drag = true; sy = e.touches[0].clientY; dy = 0; st = Date.now();
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!drag) return;
      dy = e.touches[0].clientY - sy;
      if (dy <= 0) { panel.style.transform = ''; modal.classList.remove('is-dragging'); return; }
      if (e.cancelable) e.preventDefault();
      modal.classList.add('is-dragging');
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    panel.addEventListener('touchend', function () {
      if (!drag) return; drag = false;
      var fast = dy > 40 && (Date.now() - st) < 250;
      modal.classList.remove('is-dragging');
      if (dy > 110 || fast) { closeModal(); } else { panel.style.transform = ''; }
    });
    document.body.appendChild(modal);
    return modal;
  }

  function openFor(details) {
    var titleEl = details.querySelector('.omg-acc__title');
    var bodyEl = details.querySelector('.omg-acc__body-inner');
    if (!titleEl || !bodyEl) return;
    buildModal();
    modalTitle.textContent = titleEl.textContent;
    modalBody.innerHTML = bodyEl.innerHTML;
    modalBody.scrollTop = 0;
    lastFocused = document.activeElement;
    document.body.classList.add('omg-acc-modal-open');
    /* force reflow so the transform transition runs on the next paint */
    void modal.offsetWidth;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var closeBtn = modal.querySelector('.omg-acc__modal-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!modal) return;
    var p = modal.querySelector('.omg-acc__modal-panel'); if (p) p.style.transform = '';
    modal.classList.remove('is-dragging');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('omg-acc-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus({ preventScroll: true }); } catch (_) {}
    }
  }

  /* ESC closes */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  /* intercept summary clicks on mobile only.
     Use capture phase + check the media query at click time so a viewport
     resize from desktop → mobile during the session still works. */
  document.addEventListener('click', function (e) {
    if (!window.matchMedia(MOBILE_MQ).matches) return;
    var summary = e.target && e.target.closest && e.target.closest('.omg-acc__summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    if (!details.classList.contains('omg-acc__item')) return;
    e.preventDefault();
    /* if details was already open (e.g. from before viewport became mobile),
       close it so we don't show inline content under the modal */
    if (details.open) details.removeAttribute('open');
    openFor(details);
  }, true);
})();
